export enum ChartType {
    Pie = 'PIE',
    Line = 'LINE',
    Stacked = 'STACKED',
    HorizontalBar = 'HORIZONTALBAR',
    Comparison = 'COMPARISION'
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/ChartType.ts